"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prediction_model_results_viz_1 = require("@tableau/prediction-model-results-viz");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var TestIds_1 = require("../../../util/TestIds");
var Utils_1 = require("../../../util/Utils");
var Index_1 = require("../../base/Index");
var CONTAINER_WIDTH = 500;
var CHART_WIDTH = 500;
var CHART_HEIGHT = 425;
var MIN_CORRELATION_PERCENT = 0.5;
var ModelResultTopPredictors = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (state) { return state.modelResult; }), modelFields = _a.modelFields, modelCorrelation = _a.modelCorrelation, modelOutcome = _a.modelOutcome, type = _a.type;
    if (!modelFields || !modelCorrelation || !modelOutcome) {
        return React.createElement(Index_1.Error, { message: Localize_1.Messages.chartErrorMessage(), testId: TestIds_1.MODEL_RESULT_CHART_ERROR_TEST_ID + 'top-predictors' });
    }
    var metricTitle = Localize_1.Messages.modelResultTopPredictorsTitle();
    var metricTooltip = Localize_1.Messages.topPredictorQuestion({ outcomeText: modelOutcome.name });
    var ignoreFields = modelFields.filter(function (n) { return !!n.ignored; }).map(function (n) { return n.name; });
    var correlationData = modelCorrelation.filter(function (n) { return !ignoreFields.includes(n.name) && n.correlation * 100 > MIN_CORRELATION_PERCENT; });
    var barColor = (0, Utils_1.isBinomialModel)(type) ? prediction_model_results_viz_1.VizColors.background02 : undefined;
    return (React.createElement(Index_1.Card.Container, { header: metricTitle, tooltip: metricTooltip, width: CONTAINER_WIDTH },
        React.createElement(prediction_model_results_viz_1.VariableCorrelationTable, { data: correlationData, width: CHART_WIDTH, height: CHART_HEIGHT, color: barColor })));
};
exports.default = ModelResultTopPredictors;
//# sourceMappingURL=ModelResultTopPredictors.js.map